/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../spine/options_pb.js');
goog.exportSymbol('proto.spine.base.FieldPath', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.base.FieldPath = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.base.FieldPath.repeatedFields_, null);
};
goog.inherits(proto.spine.base.FieldPath, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.base.FieldPath.displayName = 'proto.spine.base.FieldPath';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.base.FieldPath.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.base.FieldPath.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.base.FieldPath.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.base.FieldPath} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.base.FieldPath.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldNameList: jspb.Message.getRepeatedField(msg, 1)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.base.FieldPath}
 */
proto.spine.base.FieldPath.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.base.FieldPath;
  return proto.spine.base.FieldPath.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.base.FieldPath} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.base.FieldPath}
 */
proto.spine.base.FieldPath.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addFieldName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.base.FieldPath.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.base.FieldPath.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.base.FieldPath} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.base.FieldPath.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldNameList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string field_name = 1;
 * @return {!Array<string>}
 */
proto.spine.base.FieldPath.prototype.getFieldNameList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/** @param {!Array<string>} value */
proto.spine.base.FieldPath.prototype.setFieldNameList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.spine.base.FieldPath.prototype.addFieldName = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.spine.base.FieldPath.prototype.clearFieldNameList = function() {
  this.setFieldNameList([]);
};


goog.object.extend(exports, proto.spine.base);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../known_type_parsers.js');

proto.spine.base.FieldPath.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.base.FieldPath.fromObject(jsObject);
};

proto.spine.base.FieldPath.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.base.FieldPath();
  
  if (obj.fieldName !== undefined && obj.fieldName !== null) {
    obj.fieldName.forEach(
      (listItem, index, array) => {
        if (listItem !== null) {
          let value = listItem;
          msg.addFieldName(value);
        }
      }
    );
  }
  return msg;
};
